import { render, staticRenderFns } from "./retirar.vue?vue&type=template&id=5c7181b9"
import script from "./retirar.vue?vue&type=script&lang=js"
export * from "./retirar.vue?vue&type=script&lang=js"
import style0 from "./retirar.vue?vue&type=style&index=0&id=5c7181b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports